<div class="eiq-autocomplete__container">
  @if (label()) {
    <span class="eiq-autocomplete__label">
      {{ label() }}
      <span class="eiq-autocomplete__hint">{{ hint() }}</span>
    </span>
  }

  <mat-form-field appearance="outline" class="eiq-autocomplete__field" [class.eiq-autocomplete__field--multiple]="multiple()" [subscriptSizing]="'dynamic'">
    @if (multiple()) {
      <mat-chip-grid #chipGrid [disabled]="disabled()">
        @for (selected of selectedOptions$(); track selected.value) {
          <mat-chip-row [disabled]="disabled()" (removed)="removeOption(selected)" [attr.data-testid]="testId() ? testId() + '-chip-' + selected.value : null">
            {{ selected.text }}
            <button matChipRemove [disabled]="disabled()" [attr.data-testid]="testId() ? testId() + '-chip-remove-' + selected.value : null">
              <fa-icon [icon]="faClose"></fa-icon>
            </button>
          </mat-chip-row>
        }
        <input
          #input
          matInput
          type="text"
          [attr.data-testid]="testId() ? testId() + '-autocomplete' : null"
          [placeholder]="selectedOptions$().length ? '' : placeholder()"
          [attr.aria-label]="label() ?? placeholder()"
          [matAutocomplete]="auto"
          [matAutocompleteDisabled]="disabled()"
          [matChipInputFor]="chipGrid"
          [disabled]="disabled()"
          (input)="filterWhenTyping()"
          (focus)="filterWhenTyping()"
        />
      </mat-chip-grid>
      <mat-autocomplete
        #auto="matAutocomplete"
        [hideSingleSelectionIndicator]="true"
        class="eiq-autocomplete__panel--multiple"
        (optionSelected)="onOptionSelected($event)"
        (opened)="panelOpen$.set(true)"
        (closed)="panelOpen$.set(false)"
      >
        @if (!selectedOptions$().length) {
          <div class="eiq-autocomplete__search-row" (click)="$event.stopPropagation()">
            <fa-icon [icon]="faMagnifyingGlass" class="eiq-autocomplete__search-icon"></fa-icon>
            <input
              class="eiq-autocomplete__search-input"
              type="text"
              [placeholder]="searchPlaceholder()"
              [disabled]="disabled()"
              (input)="onSearchInput($event)"
              (click)="$event.stopPropagation()"
            />
          </div>
        }
        @for (option of filteredOptions$ | async; track option.value) {
          <mat-option [value]="option.value" [disabled]="disabled()">
            {{ option.text }}
            <mat-pseudo-checkbox
              [state]="isSelected(option) ? 'checked' : 'unchecked'"
              appearance="minimal"
              class="mat-mdc-option-pseudo-checkbox"
            ></mat-pseudo-checkbox>
          </mat-option>
        }
      </mat-autocomplete>
    } @else {
      <input
        #input
        matInput
        type="text"
        [attr.data-testid]="testId() ? testId() + '-autocomplete' : null"
        [placeholder]="placeholder()"
        [attr.aria-label]="label() ?? placeholder()"
        [formControl]="control"
        [matAutocomplete]="auto"
        [matAutocompleteDisabled]="disabled()"
        (input)="filterWhenTyping()"
        (focus)="filterWhenTyping()"
      />

      @if (prefixIcon()) {
        <fa-icon [icon]="prefixIcon()" matPrefix></fa-icon>
      }

      <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayFn">
        @for (option of filteredOptions$ | async; track $index) {
          <mat-option [value]="option.value">{{ option.text }}</mat-option>
        }
      </mat-autocomplete>
    }

    <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event.option.value)">
      @for (option of filteredOptions$ | async; track $index) {
        <mat-option [value]="option.value">{{ option.text }}</mat-option>
      }
    </mat-autocomplete>
    <ng-container matIconSuffix>
      @if (multiple()) {
        <fa-icon [icon]="panelOpen$() ? faChevronUp : faChevronDown" class="eiq-autocomplete__arrow"></fa-icon>
      }
    </ng-container>

    <mat-error><eiq-validation-text [formCtrl]="control"></eiq-validation-text></mat-error>
  </mat-form-field>
</div>
